// Thin fetch wrapper. Prefer `sdk` (./sdk.ts) for new code.
//
// Paths are resolved against API_BASE_URL — '' (same origin, the Vite dev
// server proxies `/v1`) unless VITE_PUBLIC_API_URL is set.

import { API_BASE_URL } from './config';

const ACCESS_TOKEN_KEY = 'sss.accessToken';

type Options = RequestInit & { auth?: boolean };

export async function api<T = unknown>(path: string, opts: Options = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(opts.headers as Record<string, string>),
  };
  if (opts.auth !== false) {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE_URL}${path}`, { ...opts, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}
